export default __webpack_public_path__ + "static/media/キャンティ.bff052c6.PNG";